// extracted by mini-css-extract-plugin
export const container = "CruiseFareInclusionsList-module--container--2EhGv";
export const titleContainer = "CruiseFareInclusionsList-module--title-container--2MSEx";
export const title = "CruiseFareInclusionsList-module--title--2n7xk";
export const subTitle = "CruiseFareInclusionsList-module--sub-title--1F0D9";
export const disclaimer = "CruiseFareInclusionsList-module--disclaimer--36bD5";
export const body = "CruiseFareInclusionsList-module--body--1l1PZ";